// I video YouTube partono solo con il consenso marketing o dopo un clic del visitatore
(function () {
	const COOKIE_POLICY_URL = '/pages/cookie-policy';

	function addStyles() {
		if (document.getElementById('yt-consent-styles')) return;
		const style = document.createElement('style');
		style.id = 'yt-consent-styles';
		style.textContent = `
			.yt-consent { position: relative; width: 100%; aspect-ratio: 16 / 9; margin: 0 auto; background: #111 center / cover no-repeat; overflow: hidden; }
			.yt-consent__play { position: absolute; inset: 0; width: 100%; height: 100%; padding: 0; border: 0; background: transparent; cursor: pointer; }
			.yt-consent__play::before { content: ''; position: absolute; top: 50%; left: 50%; width: 72px; height: 72px; margin: -36px 0 0 -36px; border-radius: 50%; background: rgba(0, 0, 0, 0.65); }
			.yt-consent__play::after { content: ''; position: absolute; top: 50%; left: 50%; margin: -14px 0 0 -8px; border-style: solid; border-width: 14px 0 14px 24px; border-color: transparent transparent transparent #fff; }
			.yt-consent__note { position: absolute; left: 0; right: 0; bottom: 0; margin: 0 !important; padding: 6px 12px; font-size: 12px; line-height: 1.4; text-align: center; color: #fff !important; background: rgba(0, 0, 0, 0.65); }
			.yt-consent__note a { color: #fff !important; text-decoration: underline; }
		`;
		document.head.appendChild(style);
	}

	function getVideoId(url) {
		const match = url.match(/\/embed\/([^?&\/]+)/);
		return match ? match[1] : '';
	}

	function getPlayerUrl(url, autoplay) {
		const playerUrl = new URL(url);
		playerUrl.hostname = 'www.youtube-nocookie.com';
		playerUrl.searchParams.set('rel', '0');
		if (autoplay) playerUrl.searchParams.set('autoplay', '1');
		return playerUrl.toString();
	}

	function loadVideo(iframe, autoplay) {
		if (autoplay) iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; web-share');
		iframe.setAttribute('allowfullscreen', '');
		iframe.src = getPlayerUrl(iframe.dataset.ytSrc, autoplay);
		iframe.removeAttribute('data-yt-src');
		iframe.style.removeProperty('display');
		if (iframe.ytConsentBox) iframe.ytConsentBox.remove();
	}

	function addPreview(iframe) {
		if (iframe.ytConsentBox) return;

		const box = document.createElement('div');
		box.className = 'yt-consent';
		box.style.maxWidth = iframe.getAttribute('width') ? iframe.getAttribute('width') + 'px' : '';
		box.style.backgroundImage = `url("//${window.Shopify.cdnHost}/shop/files/yt-${getVideoId(iframe.dataset.ytSrc)}.jpg")`;

		const button = document.createElement('button');
		button.type = 'button';
		button.className = 'yt-consent__play';
		button.setAttribute('aria-label', 'Play video' + (iframe.title ? ': ' + iframe.title : ''));
		button.addEventListener('click', () => loadVideo(iframe, true));

		const note = document.createElement('p');
		note.className = 'yt-consent__note';
		note.innerHTML = `Press play to load this video from YouTube (Google), which may use cookies. <a href="${COOKIE_POLICY_URL}">Cookie Policy</a>`;

		box.append(button, note);
		iframe.style.setProperty('display', 'none', 'important');
		iframe.ytConsentBox = box;
		iframe.parentNode.insertBefore(box, iframe);
	}

	function loadAllVideos() {
		document.querySelectorAll('iframe[data-yt-src]').forEach((iframe) => loadVideo(iframe, false));
	}

	function init() {
		addStyles();
		document.querySelectorAll('iframe[data-yt-src]').forEach(addPreview);

		document.addEventListener('visitorConsentCollected', (event) => {
			if (event.detail && event.detail.marketingAllowed) loadAllVideos();
		});

		if (!window.Shopify || !window.Shopify.loadFeatures) return;
		window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
			if (error) return;
			if (window.Shopify.customerPrivacy.marketingAllowed()) loadAllVideos();
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
